import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  rulesForTPatientSurgeryProcedure,
  procedureIdToGroup,
  procedureIpsIdToGroup,
} from "../data";

const defaultProcedure = {
  showForm: false,
  type: null,
};

export const useTPatientSurgeryProcedureRules = () => {
  const { patientSurgery } = useSelector(
    (state) => state.patient.patientSurgery
  );

  const { scheduleEvents } = useSelector(
    (state) => state.patient.scheduleEvent
  );

  const { state, track, numberEvents, procedure, patient } =
    patientSurgery.data ?? {};

  const { id: ipsId } = patient.user.ips ?? {};
  const { id: procedureParentId } = procedure.procedure.parent ?? {};

  return useMemo(() => {
    const groupKey = procedureIpsIdToGroup[`${procedureParentId}-${ipsId}`];
    if (!groupKey) return defaultProcedure;

    const flowRules = rulesForTPatientSurgeryProcedure[groupKey];
    if (!flowRules) return defaultProcedure;

    const trackRules = flowRules[track];
    if (!trackRules) return defaultProcedure;

    const rule = trackRules[state];
    if (!rule) return defaultProcedure;

    const showForm = rule.showForm({
      scheduleEvents,
      numberEvents,
    });

    return {
      type: rule.type,
      showForm,
    };
  }, [procedureParentId, ipsId, track, state, scheduleEvents, numberEvents]);
};
